module.exports = __webpack_public_path__ + "static/media/dark-theme-unique-geofence.0074552d.svg";